import { render, staticRenderFns } from "./UploadList.vue?vue&type=template&id=268254c5&scoped=true"
import script from "./UploadList.vue?vue&type=script&lang=js"
export * from "./UploadList.vue?vue&type=script&lang=js"
import style0 from "./UploadList.vue?vue&type=style&index=0&id=268254c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "268254c5",
  null
  
)

export default component.exports